import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { map, Observable, startWith } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule,MatFormFieldModule,MatInputModule],
  selector: 'app-stakeholder',
  templateUrl: './stakeholder.component.html',
  styleUrls: ['./stakeholder.component.css'],
})
export class StakeholderComponent implements OnInit {
  stakeholderControl = new FormControl('');
  changeSelectedStakeholders: any[] = [];

  filteredStakeholders!: Observable<any[]>;
  showDropdown = false;
  isHovering1 = false;
  isHovering2 = false;
  @Input() selectedStakeholders: any[] = [];
  @Input() stakeholders: any[] = [];
  @Output() onCLose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    this.filteredStakeholders = this.stakeholderControl.valueChanges.pipe(
      startWith(''), // Emit initial value
      map((value) => this.filterStakeholders(value || ''))
    );
    this.changeSelectedStakeholders = this.selectedStakeholders;
  }

  private filterStakeholders(value: any): any[] {
    const filterValue = value.toLowerCase();
    return this.stakeholders.filter((stakeholder) =>
      stakeholder.name.toLowerCase().includes(filterValue)
    );
  }

  onSelectionChange(option: any) {
    if (!this.changeSelectedStakeholders.includes(option.name)) {
      this.changeSelectedStakeholders.push({ stake_holder: option.name });
    }
    this.stakeholderControl.setValue('');
    this.showDropdown = false;
  }
  addStakeholder(option: any) {
    if (!this.changeSelectedStakeholders.includes(option.name)) {
      this.changeSelectedStakeholders.push({ stake_holder: option.name });
    }
    this.stakeholderControl.setValue('');
    this.showDropdown = false;
  }

  remove(stakeholder: any): void {
    const indexChangeStakeholder =
      this.changeSelectedStakeholders.indexOf(stakeholder);

    if (indexChangeStakeholder >= 0) {
      this.changeSelectedStakeholders.splice(indexChangeStakeholder, 1);
    }
  }

  onFocus() {
    this.showDropdown = true;
  }

  onBlur() {
    setTimeout(() => {
      this.showDropdown = false;
    }, 200);
  }
  save() {
    this.onSave.emit(this.changeSelectedStakeholders);
  }

  cancel() {
    this.onCLose.emit();
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.stopPropagation(); // Prevent Mat-Select from handling Space
    }
  }
}
